import { useGetTenantInfoQuery, useGetTenantQuery } from '../tenantApi';
import { Tenant, TenantShortInfo } from '../types';
import { useGetAvatarQuery, useGetProfileQuery } from '../../profile/api/profileApi';
import { useUserRole } from '../../user-management/hooks/useRoleProfile';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { User as UserProfile } from '../../profile/utils';
import { RoleName } from '../../../types';

export const useGetTenantDataByRole = (): {
    isLoading: boolean;
    data: Tenant | TenantShortInfo | undefined;
    userProfile: UserProfile | undefined;
    isPortalUser: boolean;
    isPlatformAdmin: boolean;
    userAvatar: any;
} => {
    const { isLoggedIn } = useSelector((state: RootState) => state.auth);
    const { data: user, isLoading: profileLoading } = useGetProfileQuery(undefined, { skip: !isLoggedIn });
    const { data: userAvatar, isLoading: avatarLoading } = useGetAvatarQuery(undefined, { skip: !isLoggedIn });

    const tenantId = user?.tenantId as number;

    const { permissions, isLoading: permissionsLoading } = useUserRole();
    const isPlatformAdmin = permissions.includes(RoleName.PLATFORM_ADMIN);
    const isPortalUser = permissions.includes(RoleName.USER);

    const { data: tenant, isLoading } = useGetTenantQuery(tenantId, {
        skip: profileLoading || permissionsLoading || !tenantId || !isPlatformAdmin,
    });

    const { data: userTenant, isLoading: isLoadingUserTenant } = useGetTenantInfoQuery(undefined, {
        skip: permissionsLoading || !permissions.length || isPlatformAdmin || !isLoggedIn,
    });

    return {
        isPortalUser,
        isPlatformAdmin,
        userProfile: user,
        data: tenant || userTenant,
        isLoading: isLoading || isLoadingUserTenant || profileLoading || permissionsLoading || avatarLoading,
        userAvatar: userAvatar,
    };
};
